module.exports = __webpack_public_path__ + "static/activate-image-d317af5a91fec7da0e9c6bf5e79dbfa3.png";